import React, { Suspense } from 'react';
import { Routes as ReactRouterRoutes, Route } from 'react-router-dom';

import { PrivateRoute, PublicRoute } from './route';
import RoutesList from './routesList';

// Componente de loading para o Suspense
const LoadingFallback = () => (
    <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
    }}>
        loading...
    </div>
);

var mainArray = [];
RoutesList.forEach(item => {
    var array = [];
    !item.isMenu && array.push(item);
    item.childrens && item.childrens.forEach(child => {
        !child.isMenu && array.push(child);
    });
    mainArray = mainArray.concat(array);
});

const Routes = () => (    
    <Suspense fallback={<LoadingFallback />}>
        <ReactRouterRoutes>
            {mainArray.map(route => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        route.isPrivate ? (
                            <PrivateRoute allowedRoles={route.allowedRoles}>
                                <route.component />
                            </PrivateRoute>
                        ) : (
                            <PublicRoute>
                                <route.component />
                            </PublicRoute>
                        )
                    }
                />
            ))}
        </ReactRouterRoutes>
    </Suspense>
);

export default Routes;
